import axios from "axios";
import { buildHeaders } from "utils/services";

const API_BASE_URL = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_VERSION;

export const fetchUsers = async (user, page, limit, alpacaFilter, sumsubFilter, startDate, endDate, search, filterType, sort, order, isPartner) => {

    const searchParam = `${search !== '' ? `&value=${search}` : ''}${filterType !== 'all' ? `&filter=${filterType}` : ''}${sort ? `&field=${sort}&order=${order}` : ''}&isPartner=${isPartner}`

    try {
        const { data } = await axios.get(`${API_BASE_URL}/users/clients?page=${page}&limit=${limit}&alpacaFilter=${alpacaFilter}&sumsubFilter=${sumsubFilter}&startDate=${startDate}&endDate=${endDate}` + searchParam,
            buildHeaders(user)
        );
        return data;
    } catch (error) {
        console.error(error);
    }
}

export const searchUsers = async (user, query, add_portfolio_value = false) => {
    try {
        const { data } = await axios.get(`${API_BASE_URL}/users/search?search=${query}&add_portfolio_value=${add_portfolio_value}`,
            buildHeaders(user)
        )
        return data

    } catch (err) {
        console.log(err)
        throw err
    }
}